import { useDispatch } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'typesafe-actions';

export const useThunkDispatch = (): ThunkDispatch<any, any, Action> => useDispatch();
